/*
 * Copyright (c) 2025. Dave van Rijn Development
 */

import React from 'react';
import {Dialog, Snackbar} from '@dvrd/dvr-controls';

export default function PopupController() {
    return (
        <>
            <Dialog className='bowies-dialog'/>
            <Snackbar/>
        </>
    );
}